webpackJsonp([142629428675168],{

/***/ 389:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by Rahul Patil","subtitle":"Cloud, Bots, AI and more..","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Rahul","email":"#","telegram":"#","twitter":"#","github":"#","rss":"#","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/hello-gatsby-2","categorySlug":"/categories/others/"},"frontmatter":{"title":"Hello Gatsby 2","date":"2018-10-25T12:40:32.169Z","category":"Others","description":"Test 2"}}},{"node":{"fields":{"slug":"/posts/hello-gatsby","categorySlug":"/categories/others/"},"frontmatter":{"title":"Hello Gatsby","date":"2018-10-24T12:40:32.169Z","category":"Others","description":"Test"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-259f5f6005694851dcbd.js